export const startsWithPunctuationRegex = /^[.,\/#!%\^&\*;:=\-_`~)]/

export const endsWithOpeningPunctuationRegex = /[([]$/

export const isAnEditRegex = /{\+([^|}]*)-([^|]*)\|([^}]*)}/g

export const negativeMatchRegex = /\-(.+)\|/m

export const spaceAfter = (word: string, nextWord?: string) => !(nextWord !== undefined && startsWithPunctuationRegex.test(nextWord)) && !endsWithOpeningPunctuationRegex.test(word)
